export default __webpack_public_path__ + "static/media/client18.2ec55d2d.jpg";